/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const updateUserInfoSchema = z.object({
      "fonction": z.string().describe("Fonction de l'utilisateur").optional(),
  "firstName": z.string().describe("Prénom de l'utilisateur").optional(),
  "lastName": z.string().describe("Nom de famille de l'utilisateur").optional()
      })